"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconDesktop', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M2 1C1.44772 1 1 1.44772 1 2V10C1 10.5523 1.44772 11 2 11H5.21921L4.71921 13H4C3.44772 13 3 13.4477 3 14C3 14.5523 3.44772 15 4 15H5.47943C5.49368 15.0003 5.50789 15.0003 5.52207 15H10.4779C10.4921 15.0003 10.5063 15.0003 10.5206 15H12C12.5523 15 13 14.5523 13 14C13 13.4477 12.5523 13 12 13H11.2808L10.7808 11H14C14.5523 11 15 10.5523 15 10V2C15 1.44772 14.5523 1 14 1H2ZM9.52278 9C9.50814 8.99968 9.49346 8.99967 9.47875 9H6.52125C6.50654 8.99967 6.49186 8.99968 6.47722 9H3V3H13V9H9.52278ZM8.71923 11L9.21923 13H6.78077L7.28077 11H8.71923Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M13.7808 16L13.2808 14H18C18.5523 14 19 13.5523 19 13V3C19 2.44772 18.5523 2 18 2L2 2C1.44772 2 1 2.44771 1 3L1 13C1 13.5523 1.44772 14 2 14H6.71922L6.21922 16H5C4.44772 16 4 16.4477 4 17C4 17.5523 4.44772 18 5 18H6.97804C6.99322 18.0003 7.00836 18.0003 7.02345 18H12.9766C12.9916 18.0003 13.0068 18.0003 13.0219 18H15C15.5523 18 16 17.5523 16 17C16 16.4477 15.5523 16 15 16H13.7808ZM12.0213 12C12.0077 11.9997 11.9939 11.9997 11.9802 12H8.01981C8.00606 11.9997 7.99234 11.9997 7.97867 12H3L3 4L17 4V12H12.0213ZM11.7192 16L11.2192 14H8.78078L8.28078 16H11.7192Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M15.8199 20L15.2199 17H22C22.5523 17 23 16.5523 23 16L23 3C23 2.44772 22.5523 2 22 2L2 2C1.44772 2 1 2.44772 1 3L1 16C1 16.5523 1.44772 17 2 17H8.78014L8.18014 20H6C5.44772 20 5 20.4477 5 21C5 21.5523 5.44772 22 6 22H8.98252C8.99488 22.0002 9.00721 22.0002 9.0195 22H14.9805C14.9928 22.0002 15.0051 22.0002 15.0175 22H18C18.5523 22 19 21.5523 19 21C19 20.4477 18.5523 20 18 20H15.8199ZM14.0217 15C14.008 14.9997 13.9943 14.9997 13.9805 15H10.0195C10.0057 14.9997 9.99197 14.9997 9.97826 15H3L3 4L21 4V15H14.0217ZM13.7803 20L13.1803 17H10.8197L10.2197 20H13.7803Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M21.1297 23H29.5C30.3284 23 31 22.3284 31 21.5L31 3.5C31 2.67157 30.3284 2 29.5 2L2.5 2C1.67157 2 1 2.67157 1 3.5L1 21.5C1 22.3284 1.67157 23 2.5 23H10.8703L10.2703 26H7.5C6.67157 26 6 26.6716 6 27.5C6 28.3284 6.67157 29 7.5 29H11.4731C11.4922 29.0004 11.5112 29.0004 11.5302 29H20.4698C20.4888 29.0004 20.5078 29.0004 20.5269 29H24.5C25.3284 29 26 28.3284 26 27.5C26 26.6716 25.3284 26 24.5 26H21.7297L21.1297 23ZM18.0703 23H13.9297L13.3297 26H18.6703L18.0703 23ZM4 20L4 5H28V20H4Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;